import { render, staticRenderFns } from "./referralBannerTab.vue?vue&type=template&id=c885bcbe&scoped=true&lang=pug"
import script from "./referralBannerTab.vue?vue&type=script&lang=js"
export * from "./referralBannerTab.vue?vue&type=script&lang=js"
import style0 from "./referralBannerTab.vue?vue&type=style&index=0&id=c885bcbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c885bcbe",
  null
  
)

export default component.exports